import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
@Pipe({
  name: 'equipments',
  standalone: true,
})
export class EquipmentsPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(equipments: string[], activeLang?: string) {
    if (!equipments || equipments.length === 0) return null;

    return equipments
      .map(e => this.translocoService.translate(e, {}, activeLang))
      .join(', ');
  }
}
